
import SignUpWelcome from "@/components/Auth/SignUpWelcome.vue";

export default {
  name: "WelcomeView",
  components: {
    SignUpWelcome,
  },
  setup() {
    return {};
  },
};
